import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import { Icon40 } from 'builder/components/Icon'
import Media from 'builder/styles/media'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${Spacing.M};

  ${Media.AboveTablet`
      max-width: 460px;
  `}
`

export const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${Spacing.XS};
`

export const Title = styled.p`
  ${Typography.S};
  ${FontWeights.DemiBold};
  color: ${Colors.Neutral90};
`

export const SubTitle = styled.p`
  ${Typography.Body};
  ${FontWeights.Regular};
  color: ${Colors.Neutral50};
`

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing['2XS']};
`

export const CardContainer = styled.label`
  display: flex;
  gap: ${Spacing.S};
  padding: ${Spacing.M};
  border-radius: 16px;
  border: 1px solid ${Colors.Neutral20};
  background: ${Colors.White};
  cursor: pointer;
  transition: box-shadow 0.3s ease-in-out;

  &:hover {
    box-shadow: 0px 2px 4px -1px rgba(15, 56, 113, 0.08), 0px 8px 20px -4px rgba(15, 56, 113, 0.12);
  }
`

export const CardContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing['2XS']};
`

export const CardTitle = styled.p`
  ${Typography.Body};
  ${FontWeights.DemiBold};
  color: ${Colors.Neutral90};
`

export const CardSubTitle = styled.p`
  ${Typography.Body};
  ${FontWeights.Regular};
  color: ${Colors.Neutral50};
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 22px;
  border-radius: ${Spacing['2XS']};
  border: 1px solid ${Colors.Neutral15};
  background: linear-gradient(180deg, #f7f9fc 0%, #fff 100%);
  width: 84px;
  height: 84px;
  min-width: 84px;
  min-height: 84px;
  color: ${Colors.Neutral40};

  ${CardContainer}:hover & {
    color: ${Colors.Blue50};
  }
`

export const IconUpload = styled(Icon40.Upload)`
  width: 40px;
  height: 40px;
`

export const IconCreate = styled(Icon40.CreateDocument)`
  width: 40px;
  height: 40px;
`

export const DividerContainer = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  width: 100%;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: linear-gradient(to right, transparent, rgba(0, 0, 0, 0.1));
  }

  &::after {
    background: linear-gradient(to left, transparent, rgba(0, 0, 0, 0.1));
  }
`

export const DividerText = styled.span`
  ${Typography.Caps};
  ${FontWeights.DemiBold};
  color: ${Colors.Neutral40};
  letter-spacing: 1.8px;
  text-transform: uppercase;
  padding: 0 20px;
`
